import type { IExtractRouteParamMap, IRouteTranslation } from "../../../types";
import { createBreadcrumbObject, createPaths, rebase } from "../../../utils";

// Base route constant
const baseRoute = `/staff`;

// * Route configuration object for staffs-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const staffsRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:staffId`,
  edit: `${baseRoute}/edit/:staffId`,
} as const;

// ! these are breadcrumbs translation not page title
const staffsRouteTranslation: IRouteTranslation<typeof staffsRoutesObj> = {
  list: "staffsList",
  create: "addUser",
  edit: "editUser",
  view: "viewUser",
};

// * Extracts the route parameters for the staffs route configuration.
export type IStaffsRouteParams = IExtractRouteParamMap<typeof staffsRoutesObj>;

// * Path functions for the staffs routes.
export const staffsPath = createPaths<
  typeof staffsRoutesObj,
  IStaffsRouteParams
>(staffsRoutesObj);

// * Breadcrumbs {translation and route} for the staffs routes
export const staffsBreadcrumbs = createBreadcrumbObject<typeof staffsRoutesObj>(
  staffsRoutesObj,
  staffsRouteTranslation,
);
rebase(staffsBreadcrumbs, "list");
